import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { BrandMaster, ColorMaster, ItemMaster, Master } from '../../../model/masters.model';
import { PurchaseOrderItemModel } from '../../../model/purchase-order.model';
import { IField } from '../../../interfaces/field.interface';
import { parseFixed } from '../../../services/formats';
import { Fields } from '../../../components/Fields';


interface IOwnProps {
  items: Array<ItemMaster>;
  brands: Array<BrandMaster>;
  colors: Array<ColorMaster>;
  defaultData?: PurchaseOrderItemModel;
  show: boolean;
  handleClose: () => void;
  handleSubmit: (item: PurchaseOrderItemModel) => void;
}
export const PurchaseOrderRow: React.FC<IOwnProps> = (props: IOwnProps) => {
  const [gsts] = useState<Array<Master>>([{ id: '0.00', name: "0%" }, { id: '5.00', name: "5%" }, { id: '12.00', name: "12%" }]);


  const { register, handleSubmit, control, reset, setValue, watch } = useForm<PurchaseOrderItemModel>({
    defaultValues: {},
    mode: "onTouched",
    reValidateMode: "onChange"
  });



  const item = watch("item");
  const qty = watch("qty");
  const rate = watch("rate");
  const gst_per = watch("gst_per");

  const itemChanged = () => {
    const selectedItem = props.items.find(t => t.id === item?.id);
    let net_rate = parseFixed(selectedItem?.rate) ?? 0;
    setValue("rate", parseFixed(net_rate));
  };

  const fields: Array<IField> = [
    {
      label: "Item",
      required: true,
      props: {
        name: "item",
        type: "typeahead",
        placeholder: "Item"
      },
      onChange: itemChanged,
      options: props.items,
    }, {
      label: "Color",
      required: true,
      props: {
        name: "color",
        type: "typeahead",
        placeholder: "Color"
      },
      options: props.colors,
    }, {
      label: "Brand",
      required: true,
      props: {
        name: "brand",
        type: "typeahead",
        placeholder: "Brand"
      },
      options: props.brands,
    }, {
      label: "Bags",
      required: true,
      props: {
        name: "bag",
        type: "number",
        placeholder: "Bags"
      }
    }, {
      label: "Qnty (Kgs)",
      required: true,
      props: {
        name: "qty",
        type: "number",
        placeholder: "Qnty (Kgs)"
      }
    }, {
      label: "Rate",
      required: true,
      props: {
        name: "rate",
        type: "number",
        placeholder: "Rate"
      }
    }, {
      label: "GST",
      required: true,
      props: {
        name: "gst_per",
        type: "select",
        placeholder: "GST"
      },
      options: gsts,
    }, {
      label: "Net Rate",
      required: true,
      props: {
        name: "net_rate",
        type: "number",
        placeholder: "Net Rate",
        readOnly: true,
      },
    }, {
      label: "Amount",
      required: true,
      props: {
        name: "amt",
        type: "number",
        placeholder: "Amount",
        readOnly: true,
      },
    }
  ];

  useEffect(() => {
    reset(props.defaultData);
    return () => {
      reset();
    }
  }, [reset, props.defaultData]);

  useEffect(() => {
    let net_rate = parseFixed(rate) ?? 0;
    if (gst_per) {
      net_rate += parseFixed(rate * gst_per / 100);
    }
    const amt = qty && net_rate ? parseFixed(qty * net_rate) : 0;
    setValue("amt", parseFixed(amt));
    setValue("net_rate", parseFixed(net_rate));
  }, [qty, gst_per, rate, setValue]);

  const onSubmit = handleSubmit(async (inputs) => {
    props.handleSubmit(inputs);
    handleClose();
  });

  const handleClose = () => {
    reset();
    props.handleClose();
  };
  return (
    <Modal
      show={props.show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      fullscreen
    >
      <Form onSubmit={onSubmit} noValidate>
        <Modal.Header className="bg-primary-subtle" closeButton>
          <Modal.Title>Item Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Fields fields={fields} control={control} register={register} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">Add to List</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};